import * as initialMoment from "moment"

import API from "@irati/utils/services/API"

import {LatLng, Position} from "../types"

/*
@todo: This is a hack to get around the problem discussed here:
https://github.com/aurelia/skeleton-navigation/issues/606
Feels like something that could be fixed in our ts setup
*/
// @ts-ignore
const moment = initialMoment.default || initialMoment

const API_CHECK_URL = "https://api.ipstack.com/check"
const API_KEY = "47345ede62a1dce3b2dbbd143d4ed4fa"
const DEFAULT_TIMEOUT = 30000
const DEFAULT_CACHE_DURATION = 1800000

type Moment = initialMoment.Moment

interface IpstackLocation {
  latLng: LatLng,
  city: string
}

interface Cache {
  timestamp: Moment | null,
  data: Position | null
}

const convertIpstackLocation = ({latitude, longitude, city}: {latitude: number, longitude: number, city: string}): IpstackLocation => {
  return {
    latLng: {
      lat: latitude,
      lng: longitude
    },
    city
  }
}

const cache: Cache = {
  timestamp: null,
  data: null
}

const getCacheData = (cacheDuration: number): Promise<Position> => {
  const now = moment()
  const {timestamp, data} = cache
  return new Promise((resolve, reject) => {
    if (timestamp && data && (now.diff(timestamp) < cacheDuration)) {
      resolve(data)
    } else {
      reject()
    }
  })
}

const updateCache = (data: Position | null, timestamp: Moment | null = moment()) => {
  cache.data = data
  cache.timestamp = timestamp
}

export const getCurrentPosition = (timeout = DEFAULT_TIMEOUT, cacheDuration = DEFAULT_CACHE_DURATION): Promise<Position> => {
  const options = {
    unAuth: true,
    params: {
      access_key: API_KEY
    }
  }
  let timeoutId: any
  if (cacheDuration <= 0) { updateCache(null, null) }

  return getCacheData(cacheDuration)
    .catch(() => {
      return new Promise<Position>((resolve, reject) => {
        timeoutId = setTimeout(() => {
          reject(new Error("geolocation.fallbackPosition.getCurrentPosition.timeoutExceeded"))
        }, timeout)
        API.get(API_CHECK_URL, options)
          .then((data) => {
            clearTimeout(timeoutId)
            const {error} = data.data
            if (error) { throw new Error(error.info) }
            const ipstackLocation = convertIpstackLocation(data.data)
            const {latLng, city} = ipstackLocation
            const newData = {
              latLng,
              city,
              isFallback: true
            }
            updateCache(newData)
            resolve(newData)
          }).catch(reject)
      })
    })
    .catch((fallbackError) => {
      clearTimeout(timeoutId)
      throw fallbackError
    })
}
